import React from "react";

const CategoriesPagination = ({ categoriesPage, totalCategoriesPages, setCategoriesPage }) => (
  <div className="flex justify-center items-center space-x-2 mt-4">
      {totalCategoriesPages > 1 && (
          <>
              <button
                  onClick={() => setCategoriesPage(Math.max(1, categoriesPage - 1))}
                  disabled={categoriesPage === 1}
                  className="text-xs text-gray-400 hover:text-gray-200 disabled:opacity-50"
              >
                  ←
              </button>
              <span className="text-xs text-gray-400">
                  {categoriesPage} / {totalCategoriesPages}
              </span>
              <button
                  onClick={() => setCategoriesPage(Math.min(totalCategoriesPages, categoriesPage + 1))}
                  disabled={categoriesPage === totalCategoriesPages}
                  className="text-xs text-gray-400 hover:text-gray-200 disabled:opacity-50"
              >
                  →
              </button>
          </>
      )}
  </div>
);

export default CategoriesPagination